export const NOOP = "fetchers/NOOP";
export const WAITING_FOR_DEPENDENCIES = "fetchers/WAITING_FOR_DEPENDENCIES";

// Use a unique-ish name so there's no chance of collision with actual parameters
// to a given query. Ideally they'd already be namespaced out into { query, path }
// like they are for useApiMutation, but it would be a lot of effort to change
// that. This will work as a stop gap for now.
export const CUSTOM_HEADERS = "reactQuery.customHeaders";
